(function(){
'use strict';
var INR=(window.MPB2B&&window.MPB2B.INR)||function(n){return Number(n).toLocaleString('en-IN');};
var wroot=document.getElementById('mpw');
if(!wroot)return;
var cards=[].slice.call(wroot.querySelectorAll('.grade'));
function bagOf(c){return parseFloat(c.getAttribute('data-bag'))||25;}
var q=cards.map(function(){return 0;});
var elG=document.getElementById('mpw-grades'),elK=document.getElementById('mpw-kg'),
    elT=document.getElementById('mpw-total'),elBtn=document.getElementById('mpw-order'),
    elConf=document.getElementById('mpw-confirm');
var td=document.getElementById('mpw-today');
if(td)td.textContent=new Date().toLocaleDateString('en-IN',{day:'2-digit',month:'short'});
var val=function(id){var e=document.getElementById(id);return e?e.value.trim():'';};

function draw(){
  cards.forEach(function(c,i){
    c.classList.toggle('sel',q[i]>0);
    var qt=c.querySelector('.qty'); qt.childNodes[0].nodeValue=q[i]+' ';
    var lt=c.querySelector('.linetotal');
    var p=parseFloat(c.getAttribute('data-price'))||0;
    if(lt){ if(q[i]>0){ lt.style.display='flex'; lt.querySelector('.ltk').textContent=(q[i]*bagOf(c))+' kg';
      lt.querySelector('.ltv').textContent=p>0?('₹'+INR(Math.round(q[i]*p))):'On request'; }
      else lt.style.display='none'; }
  });
  var kg=0,total=0,grades=0,allPriced=true;
  cards.forEach(function(c,i){ if(q[i]>0){grades++;kg+=q[i]*bagOf(c);var p=parseFloat(c.getAttribute('data-price'))||0; if(p>0)total+=q[i]*p; else allPriced=false;} });
  if(elG)elG.textContent=grades;
  if(elK)elK.textContent=INR(kg);
  if(elT)elT.textContent=grades===0?'—0':(allPriced?('₹'+INR(Math.round(total))):'On request');
  if(elBtn)elBtn.disabled=grades===0;
  var cf=document.getElementById('mpw-contact');
  if(cf) cf.style.display = grades>0 ? 'block' : 'none';
}
wroot.querySelectorAll('.stepper button').forEach(function(b){
  b.addEventListener('click',function(){var i=+b.getAttribute('data-i');q[i]=Math.max(0,q[i]+(+b.getAttribute('data-d'))); if(elConf)elConf.style.display='none'; draw();});
});

function quoteText(ref, picked, kg){
  var lines=[];
  lines.push('NEW RAW WHEY WHOLESALE ENQUIRY');
  lines.push('Reference: '+ref);
  lines.push('');
  lines.push('--- REQUESTED ---');
  picked.forEach(function(p){ lines.push('- '+p); });
  lines.push('Total volume: '+kg+' kg');
  lines.push('');
  lines.push('--- CONTACT ---');
  lines.push('Name: '+(val('mpw-name')||'-'));
  lines.push('Company: '+(val('mpw-co')||'-'));
  lines.push('Phone/WhatsApp: '+(val('mpw-phone')||'-'));
  lines.push('Email: '+(val('mpw-email')||'-'));
  lines.push('City / delivery pin: '+(val('mpw-city')||'-'));
  lines.push('');
  lines.push('Submitted from '+window.location.href);
  return lines.join('\n');
}

function flash(msg){
  var old=elBtn.textContent;
  elBtn.textContent=msg;
  setTimeout(function(){ elBtn.textContent=old; },1600);
}

if(elBtn)elBtn.addEventListener('click',function(){
  var picked=[], kg=0;
  cards.forEach(function(c,i){ if(q[i]>0){ picked.push(q[i]+' x '+bagOf(c)+'kg '+c.getAttribute('data-code')); kg+=q[i]*bagOf(c); } });
  if(!picked.length) return;

  var name=val('mpw-name'), phone=val('mpw-phone'), email=val('mpw-email');
  if(!name) return flash('Add your name');
  if(!phone && !email) return flash('Add phone or email');

  var ref=(window.MPLead? window.MPLead.ref('WHEY') : 'WHEY-'+Date.now());
  var body=quoteText(ref, picked, kg);

  elBtn.disabled=true; elBtn.textContent='Sending…';

  var done=function(ok){
    elBtn.disabled=false; elBtn.textContent='Request a quote →';
    if(elConf){
      elConf.style.display='block';
      elConf.querySelector('.sel').textContent=picked.join(' · ')+' · '+kg+' kg';
      var refEl=elConf.querySelector('.mpw-ref'); if(refEl) refEl.textContent='REF · '+ref;
      var waEl=elConf.querySelector('.mpw-wa');
      if(waEl && window.MPLead){
        waEl.href=window.MPLead.waLink(ok? ('Hi MetaPro, I submitted raw whey enquiry '+ref+'. Please share your quote.') : body);
        waEl.style.display='inline-flex';
      }
      var st=elConf.querySelector('.mpw-status');
      if(st) st.innerHTML = ok
        ? 'Your enquiry is with our team. We reply with a quote and freight cost.'
        : '<b>We could not send this automatically.</b> Please tap WhatsApp below or call +91 98151 18798.';
      elConf.scrollIntoView({behavior:'smooth',block:'center'});
    }
  };

  if(window.MPLead){ window.MPLead.send({name:name,email:email,phone:phone,body:body}).then(done); }
  else { done(false); }
});

var clr=document.getElementById('mpw-clear'); if(clr)clr.addEventListener('click',function(){q=q.map(function(){return 0;}); if(elConf)elConf.style.display='none'; draw();});
draw();
})();
